<mat-card class="assetView mat-elevation-z4 " style="background-color: var(--color-red);">
	<mat-card-header>
		<mat-card-title>{{asset.Name}}</mat-card-title>
	</mat-card-header>

	<mat-card-content class="cardContent" (click)="triggerEvent(asset)">
		<!-- <hr> -->
		<img src="{{imagePathAssets()}}{{asset.AssetID}}?{{asset.Modified}}" style="max-width: 200px;"
			onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
			[attr.x-contenttype]="'image/png'" alt="Image for {{asset.Name}}" />
		<span>{{asset.Description}}</span>
	</mat-card-content>
	<mat-card-actions class="flex-row" style="display: flex" *ngIf="false">
		<button class="app-icon app-icon--edit" mat-flat-button color="primary" *ngIf="true" title="Manage" style="margin: auto;">
			<mat-icon class="point-hand"/>
		</button>
		<button mat-flat-button color="primary" *ngIf="true" title="View Assets" style="margin: auto;">
			<mat-icon class="point-hand">table_view</mat-icon>
		</button>
	</mat-card-actions>

	<mat-card-footer>
		<span style="display: flex; justify-content: space-between; width: 100%;">
			<span style="display: flex;"><!-- Add a space --></span>
			<span class="no-wrap-tooltip app-icon app-icon--edit" style="display: flex;" matTooltip="Edit {{asset.Name}} Details"
				matTooltipPosition="above">
				<mat-icon style="color: lightgray;" (click)="editAsset(asset)"/>
			</span>
		</span>
	</mat-card-footer>
</mat-card>
